module.exports = __webpack_public_path__ + "static/media/icon_check_off.02e0637e.svg";